<template>
	<v-container fluid >
		<div class="bottom-buttons-outer">
			<v-btn @click="backClick" color="success">
				<v-icon small>fa-reply</v-icon>&nbsp;{{$t('buttons.back')}}
			</v-btn>
			<v-btn @click="saveClick" color="success">
				<v-icon small>fa-save</v-icon>&nbsp;{{$t('buttons.save')}}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex lg8 md12 pa-1 sm12 xl6 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<v-layout row wrap>
									<v-flex xs12>
										<InputField :error="destinationValidation.name"
													:label="'* '+$t('fields.name')"
													v-model="destination.name"></InputField>
									</v-flex>
									<v-flex xs12>
										<CheckBox
											:label="$t('fields.active')"
											v-model="destination.active"></CheckBox>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import InputField from "./trinkets/InputField";
	import CheckBox from "./trinkets/CheckBox";

	export default {
		name: "Destination",
		components: {CheckBox, InputField},
		props: {
			id: Number,
			action: String
		},
		data: function () {
			return {
				initialLoad: false,
				destination: {
					id: this.$route.params.id,
					name: '',
					active: true
				},
				destinationValidation: {
					id: '',
					name: '',
					active: ''
				},
				changesHappened: false
			}
		},
		watch: {
			destination: {
				handler: function () {
					if (this.initialLoad) {
						this.changesHappened = true;
					}
				},
				deep: true
			},
		},
		methods: {
			backClick() {
				this.$router.go(-1);
			},
			saveClick() {
				let success = true;

				if (this.destination.name == '') {
					success = false;
					this.destinationValidation.name = this.$t('alerts.fieldError');
				} else {
					this.destinationValidation.name = '';
				}

				if (success) {
					let vm = this;
					let action = 'post';
					let addition = '';
					if (vm.destination.id != 0) {
						action = 'put';
						addition = '/' + vm.destination.id;
					}
					vm.$APICall(action, 'destinations' + addition, vm.destination, (data, success) => {
						if (success) {
							vm.changesHappened = false;
							if (vm.destination.id == 0) {
								vm.$notify(vm.$t('alerts.basicAdd'));
							} else {
								vm.$notify(vm.$t('alerts.basicUpdate'));
							}
							vm.$triggerReload();
							vm.backClick();
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			},
		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			}
			this.$setSubMenu('Lists');
			if (this.destination.id != 0) {
				let vm = this;
				this.$APICall('get', 'destinations/' + this.destination.id, {}, (data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.destination = usableData;
						vm.$myStore.commit('setBreadcrumbs', [
							{text: vm.$t('modules.destinations'), href: '/#/destinations', disabled: false},
							{text: vm.destination.name, href: '/#/destinations/' + vm.destination.id, disabled: true}
						]);
						vm.$nextTick(() => {
							vm.initialLoad = true;
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			} else {
				this.$myStore.commit('setBreadcrumbs', [
					{text: this.$t('modules.destinations'), href: '/#/destinations', disabled: false},
					{text: this.$t('modules.newDestination'), href: '/#/destinations/0', disabled: true}
				]);
				this.initialLoad = true;
			}
		},
		beforeRouteLeave(to, from, next) {
			if (this.changesHappened) {
				this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
					next(result);
				});
			} else {
				next(true);
			}
		}
	}
</script>

<style scoped>
</style>
